export class FetchUniversities {
  static readonly type = '[University] Fetch';

  constructor(public ids: [], public selections: [], public allDB: string) {
  }
}


export class AddErrorMessage {

  static readonly type = '[University] AddErrorMessage';

  constructor(public formData: FormData) {
  }
}

export class ClearUploaded {

  static readonly type = '[University] ClearUploaded';

  constructor() {
  }
}

export class ChangeProfileUniversity {

  static readonly type = '[University] ChangeProfileUniversity';

  constructor(public formData: FormData) {
  }
}
